<div class="flex max-h-[42vh] flex-col gap-1 overflow-y-auto 2xl:max-h-[55vh]">
  <div class="flex h-14 items-center justify-between rounded-t-xl p-5" [ngClass]="bgColor ?? 'bg-amber-300'">
    <span class="text-lg font-medium text-white">{{ title | translate }}</span>
  </div>
  @for (attachment of attachments; track attachment) {
    <div
      class="flex h-14 w-full flex-row items-center justify-between rounded-lg border border-solid border-base-gray-light-400 p-3 shadow-sm shadow-base-gray-200"
    >
      <div class="flex flex-row items-center justify-center gap-4">
        <div class="w-5">
          <svg-icon class="w-2" [src]="onIconFile(attachment.extension)"></svg-icon>
        </div>
        <div class="flex flex-col">
          <span class="text-base font-medium leading-none text-black">{{ attachment.title }}</span>
          <span class="text-xs font-medium leading-none text-base-gray-300">
            {{ (attachment.size / 1000000).toFixed(2) | number }}MB"
          </span>
        </div>
      </div>
      <div class="flex">
        @if (!!canDownload(attachment.extension)) {
          <button app-button type="button" (click)="onDownload(attachment.id)">
            <svg-icon class="w-6" src="assets/icons/icon-download.svg"></svg-icon>
          </button>
        }
        <button app-button type="button" (click)="onOpenFile(attachment)">
          <svg-icon class="mt-1 w-6" src="assets/icons/icon-view.svg"></svg-icon>
        </button>
      </div>
    </div>
  }
</div>
